import { useCallback } from 'react';
import type { PointOfInterestEntities } from '@placer-ui/types';
import { useSelector } from 'react-redux';
import { selectMarketsInPropertyCategoriesIds } from 'store/selectors/app-selectors';
import { getFeatureFlags } from 'core/flow-control';

/*
 * Hook that returns a function that verifies if the entity is supported for insights report
 */
export const useGetInsightsEntityVerifier = () => {
    const marketInPropertySupportedCategories = useSelector(selectMarketsInPropertyCategoriesIds);
    return useCallback(
        ({ entity_section, category_info }: PointOfInterestEntities) => {
            if (entity_section === 'chain') return false;
            if (entity_section === 'market') {
                return !!(
                    getFeatureFlags().enable_market_in_property &&
                    marketInPropertySupportedCategories?.includes(Number(category_info?.primary_id))
                );
            }
            return true;
        },
        [marketInPropertySupportedCategories],
    );
};
